/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { keyBy, camelCase, mapValues, pick, memoize } from 'lodash';
import { StyleSheet } from 'aphrodite';
import { BrandColors } from '@blend/enterprise-components';
import { removeDefaultAnchorStyling } from 'blb-styles/mixins';
import { getColumnConfigurations } from './configs';
export const getStyles = memoize(principalType => {
  return StyleSheet.create({
    firstColumnIndent: {
      paddingLeft: 40
    },
    footerElement: {
      display: 'flex',
      marginLeft: 5
    },
    footerInnerContainer: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between'
    },
    innerCellWrapper: {
      alignItems: 'center',
      display: 'flex',
      height: 54
    },
    navLink: {
      ...removeDefaultAnchorStyling(),
      alignItems: 'center',
      display: 'flex',
      flexGrow: 1,
      height: '100%'
    },
    pipelineTableContainer: {
      flexGrow: 1,
      overflow: 'auto'
    },
    pipelineTableFooter: {
      alignItems: 'center',
      display: 'flex',
      flexBasis: `100px`,
      flexGrow: 0,
      flexShrink: 0,
      justifyContent: 'flex-end',
      padding: `0px 32px`
    },
    tableBody: {
      width: '100%'
    },
    tableHeader: {
      backgroundColor: 'white',
      cursor: 'pointer',
      position: 'sticky',
      top: 0
    },
    tableRowBase: {
      height: 54
    },
    tableRowEven: {
      backgroundColor: BrandColors.BACKGROUND_GREY
    },
    tableRowOdd: {
      backgroundColor: BrandColors.WHITE
    },
    ...mapValues(keyBy(getColumnConfigurations(principalType), _ref => {
      let {
        id
      } = _ref;
      return camelCase(id);
    }), config => pick(config, 'width'))
  });
});